import { colors, spacing } from 'material-ui/styles';
import { lighten, darken, fade } from 'material-ui/utils/colorManipulator.js'

let palette = {
    primary1Color: colors.red500,
    primary2Color: colors.red400,
    primary3Color: colors.red300,
    accent1Color: colors.greenA700,
    accent2Color: colors.greenA400,
    accent3Color: colors.greenA200,
    textColor: colors.grey600,
    canvasColor: colors.faintBlack,
    borderColor: colors.red500,
    disabledColor: colors.minBlack
};

let Theme = {

    palette: palette,
    appBar: {
        color: palette.primary1Color,
        textColor: colors.darkWhite,
        height: spacing.desktopKeylineIncrement
    },
    button: {
        height: 36,
        minWidth: 88,
        iconButtonSize: spacing.iconSize * 2
    },
    checkbox: {
        boxColor: palette.textColor,
        checkedColor: palette.primary1Color,
        requiredColor: palette.primary1Color,
        disabledColor: palette.disabledColor,
        labelColor: palette.textColor,
        labelDisabledColor: palette.disabledColor
    },
    datePicker: {
        //color: palette.accent1color,
        //textColor: colors.black,
        calendarTextColor: colors.black
        //selectColor: palette.accent2Color,
        //selectTextColor: colors.white
    },
    dropDownMenu: {
        accentColor: palette.canvasColor
    },
    flatButton: {
        color: palette.canvasColor,
        textColor: palette.textColor,
        primaryTextColor: palette.accent1Color,
        secondaryTextColor: palette.primary1Color
    },
    floatingActionButton: {
        buttonSize: 56,
        miniSize: 40,
        color: palette.accent1Color,
        iconColor: colors.white,
        secondaryColor: palette.primary1Color,
        secondaryIconColor: colors.white
    },
    leftNav: {
        width: spacing.desktopKeylineIncrement * 4,
        color: colors.white
    },
    listItem: {
        nestedLevelDepth: 18
    },
    menu: {
        backgroundColor: colors.white,
        containerBackgroundColor: colors.white
    },
    menuItem: {
        dataHeight: 32,
        height: 48,
        hoverColor: 'rgba(0, 0, 0, .035)',
        padding: spacing.desktopGutter,
        selectedTextColor: palette.accent1Color
    },
    menuSubheader: {
        padding: spacing.desktopGutter,
        borderColor: palette.borderColor,
        textColor: palette.primary1Color
    },
    paper: {
        backgroundColor: colors.white
    },
    radioButton: {
        borderColor: palette.textColor,
        backgroundColor: colors.white,
        checkedColor: palette.primary1Color,
        requiredColor: palette.primary1Color,
        disabledColor: palette.disabledColor,
        size: 24,
        labelColor: palette.textColor,
        labelDisabledColor: palette.disabledColor
    },
    raisedButton: {
        color: colors.white,
        textColor: palette.textColor,
        primaryColor: palette.accent1Color,
        primaryTextColor: colors.white,
        secondaryColor: palette.primary1Color,
        secondaryTextColor: colors.white
    },
    slider: {
        trackSize: 2,
        trackColor: colors.minBlack,
        trackcolorselected: colors.grey500,
        handleSize: 12,
        handleSizeDisabled: 8,
        handleColorZero: colors.grey400,
        handleFillColor: colors.white,
        selectionColor: palette.primary3Color,
        rippleColor: palette.primary1Color
    },
    snackbar: {
        textColor: colors.white,
        backgroundColor: '#323232',
        actionColor: palette.accent1Color
    },
    table: {
        backgroundColor: colors.white
    },
    tableHeader: {
        borderColor: palette.borderColor
    },
    tableHeaderColumn: {
        textColor: colors.lightBlack,
        height: 56,
        spacing: 28
    },
    tableFooter: {
        borderColor: palette.borderColor,
        textColor: colors.lightBlack
    },
    tableRow: {
        hoverColor: colors.grey200,
        stripeColor: lighten(palette.primary1Color, 0.55),
        selectedColor: colors.grey300,
        textColor: colors.darkBlack,
        borderColor: palette.borderColor
    },
    tableRowColumn: {
        height: 48,
        spacing: 28
    },
    timePicker: {
        color: colors.white,
        textColor: colors.grey600,
        accentColor: palette.primary1Color,
        clockColor: colors.black,
        selectColor: palette.primary2Color,
        selectTextColor: colors.white
    },
    toggle: {
        thumbOnColor: palette.primary1Color,
        thumbOffColor: colors.grey50,
        thumbDisabledColor: colors.grey400,
        thumbRequiredColor: palette.primary1Color,
        trackOnColor: fade(palette.primary1Color, 0.5),
        trackOffColor: colors.minBlack,
        trackDisabledColor: colors.faintBlack,
        labelColor: palette.textColor,
        labelDisabledColor: palette.disabledColor
    },
    toolbar: {
        backgroundColor: darken('#eeeeee', 0.05),
        height: 56,
        titleFontSize: 20,
        iconColor: 'rgba(0, 0, 0, .40)',
        separatorColor: 'rgba(0, 0, 0, .175)',
        menuHoverColor: 'rgba(0, 0, 0, .10)'
    },
    tabs: {
        backgroundColor: palette.primary1Color
    },
    textField: {
        textColor: palette.textColor,
        hintColor: palette.disabledColor,
        floatingLabelColor: palette.textColor,
        disabledTextColor: palette.disabledColor,
        errorColor: colors.red500,
        underlineFocusStyle: {borderColor: colors.grey50},
        focusColor: palette.primary1Color,
        backgroundColor: 'transparent',
        borderColor: palette.borderColor
    }
};

export default Theme;



// WEBPACK FOOTER //
// /src/theme.js